import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from 'actions/chat';
import * as webRTCActions from 'actions/chat/webrtc';
import * as fileUploadActions from 'actions/chat/fileUpload';
import * as botActions from 'actions/chat/bot';
import ChatMain from 'components/chat/';


export default connect(
  state => ({
    companionAvailable: state.app.companionAvailable,
    companionConfiguration: state.chat.main.clientConfiguration.companion,
    queueProperties: state.chat.main.queueProperties,
    validationResult: state.chat.main.validationResult,
    client: state.chat.main.client,
    pendingNotifications: state.chat.main.pendingNotifications,
    notificationsEnabled: state.chat.main.clientConfiguration.notificationsEnabled,
    notificationConfiguration: state.chat.main.clientConfiguration.notification,
    allowedWebRTCFeatures: state.chat.main.clientConfiguration.allowedWebRTCFeatures,
    customSiteUrlHexEncoded: state.chat.main.customSiteUrlHexEncoded,
    userFocus: state.chat.main.userFocus,
    loading: state.chat.main.loading,
    error: state.chat.main.error,
    ended: state.chat.main.ended,
    started: state.chat.main.started,
    routing: state.chat.main.routing,
    chatting: state.chat.main.chatting,
    connectionId: state.chat.main.connectionId,
    userTyping: state.chat.main.userTyping,
    hubStarted: state.chat.main.hubStarted,
    hubStartedTime: state.chat.main.hubStartedTime,
    routingAttempts: state.chat.main.routingAttempts,
    delayBetweenRoutingAttempts: state.chat.main.delayBetweenRoutingAttempts,
    tpClientInstanceUrl: state.chat.main.clientConfiguration.signalRInstanceURL,
    offeredToKeepWaiting: state.chat.main.offeredToKeepWaiting,
    chatted: state.chat.main.chatted,
    surveyTextHeader: state.chat.interactiveSurvey
      && state.chat.interactiveSurvey.surveyInformation
      && state.chat.interactiveSurvey.surveyInformation.textHeader,
    mailTranscriptSent: state.chat.main.mailTranscriptSent,
    endAfterVideoClosed: state.chat.main.clientConfiguration.endAfterVideoClosed,
    thankAndReload: state.chat.main.clientConfiguration.thankAndReload,
    pollingForAgentImagesEnabled: state.chat.main.clientConfiguration.fileUpload.pollingForAgentImagesEnabled,
    pollingForAgentImagesInterval: state.chat.main.clientConfiguration.fileUpload.pollingForAgentImagesInterval,
    alreadyReceivedImages: Array.from(state.chat.fileUpload.receivedImages.keys()),
    botConfiguration: state.chat.main.clientConfiguration.bot,
    botState: state.chat.bot,
  }),
  dispatch => bindActionCreators(({
    onOutOfSchedule: actions.outOfScheduleData,
    onNetworkError: actions.networkError,
    onHubStarted: actions.hubStart,
    onHubStartError: actions.hubStartError,
    onRoutingFail: actions.routingFail,
    onRoutingSuccess: actions.routingSuccess,
    onChatEnd: actions.chatEnded,
    onMessageReceived: actions.messageReceived,
    onMessageSent: actions.messageSent,
    onInitError: actions.initError,
    onAgentTyping: actions.agentTyping,
    onAgentNotTyping: actions.agentNotTyping,
    onUserTyping: actions.userTyping,
    onUserNotTyping: actions.userNotTyping,
    onSendMailTranscript: actions.sendMailTranscript,
    onMailTranscriptSent: actions.sendMailTranscriptSuccess,
    onMailTranscriptError: actions.sendMailTranscriptError,
    onFocus: actions.focus,
    onBlur: actions.blur,
    onWebRTCAgentSide: webRTCActions.agentSupported,
    onEndWebRTC: webRTCActions.end,
    onPollForAgentImages: fileUploadActions.receiveImages,
    onBotEnd: botActions.end,
    onStartHub: actions.startHub,
    onBotError: botActions.fail,
    onBotActivityPublished: botActions.activityPublished,
    onBotActivityReceived: botActions.activityReceived,
    onBotStatusChanged: botActions.statusChanged,
    onSingleFileUpload: fileUploadActions.singleUpload
  }), dispatch)
)(ChatMain);



// WEBPACK FOOTER //
// ./containers/chat/index.js